import React from "react"

import { IPanelProps, Panel } from "core/decorators/Panel";

import MessageNotificationConfig from "./MessageNotification"
import { Card, Icon, Popover, PopoverInteractionKind } from "@blueprintjs/core";
import { DialogView } from "common/views/dialog/Dialog.view";
import { ButtonView } from "common/views/button/Button.view";
import { IconNames } from "@blueprintjs/icons";
import { Message } from "panels/organizationAdmin/entities/Message";
import { iDef } from "core/util/TypeUtils";
import Loading from "common/fragments/Loading";
import { isEmpty } from "lodash";
import NonIdealState from "common/fragments/NonIdealState";
import labelProvider from './MessageNotification.label';
import Query from "core/api/QueryComponent";
import { validateEnum, validateList } from "core/util/ParamUtil";
import { Type } from "common/entities/IMessage";
import TokenSession from "core/util/session/TokenSession";
import DateTimeUtil from "core/util/DateTimeUtil";
import MessageCount from "panels/organizationAdmin/entities/MessageCount";
export interface IState {
    isOpen: boolean;
    openNotification:boolean;
    currentMsg?:Message;
    currentPageSize:number;
    lastLoginDate:Date;
    unRead:boolean;
}
const { Labels } = labelProvider;


@Panel({ id: "message-notification", configClass: MessageNotificationConfig, pageParams: true })
export default class MessageNotificationPanel extends React.Component<IPanelProps<MessageNotificationConfig>, IState> {

     defaultPageSize= 10;

    public constructor(props) {
        super(props);
        const {config}= this.props;
        let user= TokenSession.getUser();
        this.state = {
            isOpen: false, openNotification: false,
            currentPageSize: iDef(config.pageSize) ? config.pageSize : this.defaultPageSize,
            lastLoginDate: user.getLastLoginDate(), unRead: true
        }
    }

    private handleOnMessageClick = (msg:Message) => {
        this.setState({ isOpen: true,  currentMsg:msg})
    }

    private content = (config: MessageNotificationConfig) => {

        return (
            <Query.Many entity={Message} args={{
                targetGroupIds: [],
                startDate: this.getCurrentDate(),
                endDate: this.getCurrentDate(),
                pageSize: this.state.currentPageSize,
                sort: validateList(['-startDate', 'name'], config.sort, '-startDate'),
                type: validateEnum(Type, config.type, null),
                useUserGroups: true
            }}>
                {({ data, loading }) => {
                    if (loading) {
                        return <Loading />;
                    }

                    if (!data) {
                        return (
                            <NonIdealState
                                title={<Labels.NotificationEmpty />}
                                description={<Labels.NotificationNotfoundDescription />}
                            />
                        );
                    }

                    if (isEmpty(data)) {
                        return (
                            <NonIdealState
                                title={<Labels.NotificationEmpty />}
                                description={<Labels.NotificationNotfoundDescription />}
                            />
                        );
                    }

                    const messageData = data;
                    return (
                        <Query.Many entity={MessageCount} args={{
                            targetGroupIds: [],
                            startDate: this.getCurrentDate(),
                            endDate: this.getCurrentDate(),
                            pageSize: this.state.currentPageSize,
                            sort: validateList(['-startDate', 'name'], config.sort, '-startDate'),
                            type: validateEnum(Type, config.type, null),
                            useUserGroups: true
                        }}>
                            {({ data, loading }) => {
                                if (loading) {
                                    return <Loading />;
                                }

                                if (!data) {
                                    return null;
                                }

                                const count = data && data['count'];
                    return <Card
                        style={{
                            width: config.width, 
                            overflowY: 'scroll', 
                            maxHeight: config.maxHeight, 
                            alignItems: 'centre', 
                            scrollbarWidth: 'none'
                        }}>
                        {messageData.map(msg => {
                            
                            return (
                                <Card onClick={() => this.handleOnMessageClick(msg)} interactive={true} style={{ margin: 10 }}>
                                    <div dangerouslySetInnerHTML={{ __html: msg.summary }} />
                                </Card>

                            )
                        })}
                        {count > messageData.length ? (
                        <ButtonView viewKey="notificationicon.loadMore"
                            onClick={() => {
                                this.setState({ currentPageSize: this.state.currentPageSize + (iDef(config.pageSize) ? config.pageSize : this.defaultPageSize) })
                            }}>
                            Load More
                            </ButtonView>) : ''
                        }
                    </Card>
                }}
                        </Query.Many>
                    )
                }}
            </Query.Many>
        );
    }

    private toggleOpen = () => this.setState({ isOpen: !this.state.isOpen });
    private toggleOpenNotification = () => {
        this.setState({ openNotification: !this.state.openNotification, unRead:false });
    }

    private renderDescription() {
        return <DialogView
            isOpen={this.state.isOpen}
            onClose={this.toggleOpen}
            viewKey="dialog"
            title={<div dangerouslySetInnerHTML={{ __html: "<p>Notification Message</p>" }} />}
        >
            <div dangerouslySetInnerHTML={{ __html: this.state.currentMsg.description }} />
        </DialogView>
    }


    public render() {

        const { config } = this.props;

        return <Query.Many entity={Message} args={{
            targetGroupIds: [],
            pageSize: 1,
            sort: '-startDate',
            type: validateEnum(Type, config.type, null),
            startDate: this.getCurrentDate(),
            endDate:this.getCurrentDate(),
            useUserGroups: true,   
        }}>
            {({ data, loading }) => {
                if (loading) {
                    return <Loading />;
                }

                return (<React.Fragment>
                    <Popover
                        content={this.content(config)}
                        isOpen={this.state.openNotification}
                        position="bottom"
                    >
                       <ButtonView viewKey="message.icon" onClick={this.toggleOpenNotification}>
                            <Icon icon={IconNames.NOTIFICATIONS} iconSize={config.iconSize}
                                color={data !== null && data.length >= 1 && this.isAfterDate(data[0].startDate) && this.state.unRead ? "red" : ""}></Icon>
                    </ButtonView>
                    </Popover>
                    
                  
                    {this.state.isOpen && this.renderDescription()}
                </React.Fragment>)
            }}
        </Query.Many>

    }

    private isAfterDate= (startDate: string) => {
       let result= DateTimeUtil.isAfter(this.state.lastLoginDate,startDate);
       return result; 
    }

    private getCurrentDate= ()=> DateTimeUtil.formatDate(new Date(), 'en', 'YYYY-DD-MM');


}


// WEBPACK FOOTER //
// ./src/panels/message/MessageNotification.panel.tsx